import { Directive, ElementRef, OnInit, inject } from '@angular/core';

@Directive({
    selector: '[appIntersectionObserver]',
    standalone: true
})
export class IntersectionObserverDirective implements OnInit {

    // same as constructor() {}
    private elementRef = inject(ElementRef);

    private observer!: IntersectionObserver;
    options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    }

    ngOnInit(): void {

        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show')
                    // console.log('Element is in the viewport');

                }
                else {
                    // entry.target.classList.remove('show')
                    // console.log('Element is out of the viewport');
                }
            });
        }, this.options);

        const hiddenElements = this.elementRef.nativeElement.querySelectorAll('.hidden');
        // console.log('hiddenElements', hiddenElements)
        hiddenElements.forEach((el: any) => this.observer.observe(el))
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }
}